const Property_Input_Widget_Button_Collection = function (opts) {
    // this.input_type = 'charcoal/admin/property/input/widgetbutton';
    Charcoal.Admin.Property.call(this, opts)

    this.input_id = '';
    this.modal_title = '';
    this.widget_type = '';
    this.widget_options = '';

    this.set_properties(opts)

    this.element().on('click', (event) => this.showCollection(event))
};

Property_Input_Widget_Button_Collection.prototype = Object.create(Charcoal.Admin.Property.prototype);
Property_Input_Widget_Button_Collection.prototype.constructor = Property_Input_Widget_Button_Collection;
Property_Input_Widget_Button_Collection.prototype.parent = Charcoal.Admin.Property.prototype;

Property_Input_Widget_Button_Collection.prototype.set_properties = function (opts) {
    this.input_id = opts.id || this.input_id;

    this.modal_title = opts.data.modal?.title || this.modal_title;
    this.widget_type = opts.data.widget_type || opts.data.type || this.widget_type;
    this.widget_options = opts.data || this.widget_options;

    return this;
};

Property_Input_Widget_Button_Collection.prototype.showCollection = function (event) {
    const defaultOpts = {
        size:           BootstrapDialog.SIZE_WIDE,
        title:          this.modal_title,
        widget_type:    this.widget_type,
        widget_options: this.widget_options
    };

    const dialogOpts = $.extend({}, defaultOpts);

    Charcoal.Admin.Widget.prototype.dialog(dialogOpts, function (response) {
        if (response.success) {
            console.log(response)
            // Call the quickForm widget js.
            // Really not a good place to do that.
            if (!response.widget_id) {
                return false;
            }

            // Re render.
            // This is not good.
            Charcoal.Admin.manager().render();
        }
    });
};

Charcoal.Admin.Property_Input_Widget_Button_Collection = Property_Input_Widget_Button_Collection;
